import http from './http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// get请求
// export function getUserInfoAjax() {
//     return http.get('/myHomePage/getUserInfo', )
// }

//刷新token
export function refreshToken(token){
    return http.post('/admin-api/system/auth/refresh-token?refreshToken='+token)
}
//获取用户信息
export function getUserInfoAjax(params){
    return http.get('/admin-api/thesis/reply/group/getUserMeetingInfo',params)
}


export function getUserSig() {
    return http.get('/teacherReply/getUserSig', )
}

export function getStuUserInfo() {
    return http.get('/stuBase/info', )
}

//结束会议
export function endMeetingAjax(data) {
    return http.post('/admin-api/thesis/reply/group/endMeeting',data )
}


//获取当前会议是否在录制
export function getRecordStatusAjax(data){
    return http.post('/admin-api/thesis/reply/group/getRecordStatus',data)
}

//开始录制
export function beginRecordAjax(data){
    return http.post('/admin-api/thesis/reply/group/beginRecord',data)
}

//结束录制
export function endRecordAjax(data){
    return http.post('/admin-api/thesis/reply/group/endRecord',data)
}

// 切换支持人

export function changeHostAjax(data){
    return http.post('/admin-api/thesis/reply/group/changeHost',data)
}